import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flowRevision"];
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
// @ts-expect-error untyped module
import FeedbackLoader from 'feedback-loader';
import { SIDE_PANEL_WIDTH } from 'automation-ui-core/constants/ui';
import { useFeaturePermission } from 'automation-ui-permissions/feature-permissions/hooks/featurePermissionHooks';
import { EDIT_ENROLLMENT } from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { DataPanelVisibleStates } from 'automation-ui-formula-editor/data-passing-panel/DataPassingContext';
import DataPassingProviderWrapper from 'automation-ui-canvas/containers/DataPassingProviderWrapper';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { getBaseCanvasRoute } from 'automation-ui-enrollment/utils/enrollmentUrls';
import { EVENT_TRIGGERS_BETA_SURVEY_ID } from 'automation-ui-enrollment/constants/FeedbackSurvey';
import { getSidebarWidthForDataPanelState } from 'automation-ui-canvas/components/panels/utils/getSidebarWidthForDataPanelState';
import ConfigPanel from 'automation-ui-canvas/components/panels/ConfigPanel';
import withRevision from 'automation-ui-canvas/decorators/RevisionDecorator';
import EnrollmentContainer from 'automation-ui-canvas/containers/EnrollmentContainer';
import { useFlpAccess } from 'automation-ui-permissions/flp/hooks/useFlpAccess';
import DataPassingPanel from 'automation-ui-formula-editor/data-passing-panel/DataPassingPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ColumnContainer = styled.div.withConfig({
  displayName: "EnrollmentPanel__ColumnContainer",
  componentId: "pfn9dr-0"
})(["display:flex;height:100%;"]);
const LeftPanelContainer = styled.div.withConfig({
  displayName: "EnrollmentPanel__LeftPanelContainer",
  componentId: "pfn9dr-1"
})(["display:flex;flex-direction:column;height:100%;flex-basis:", "px;flex-shrink:0;overflow:hidden;"], SIDE_PANEL_WIDTH);
const RightPanelContainer = styled.div.withConfig({
  displayName: "EnrollmentPanel__RightPanelContainer",
  componentId: "pfn9dr-2"
})(["border-left:", " solid ", ";background-color:", ";position:relative;"], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.color['fill-surface-default']);
const RevisionEnrollmentContainer = withRevision(_ref => {
  let {
      flowRevision
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return flowRevision ? /*#__PURE__*/_jsx(EnrollmentContainer, Object.assign({}, props, {
    flow: flowRevision.flow
  })) : null;
});
export default function EnrollmentPanel({
  enrollmentView,
  flow,
  updateEnrollmentCriteria,
  isRevisionPreview,
  scrollElementRef
}) {
  var _flow$flowId, _flow$flowId3, _flow$objectTypeId;
  const [actionConfigDataPanelDisplay, setActionConfigDataPanelDisplay] = useState(DataPanelVisibleStates.CLOSED);
  const [showEventEnrollmentFeedbackSurvey, setShowEventEnrollmentFeedbackSurvey] = useState(false);
  const history = useHistory();
  const params = useParams();
  const {
    data: flpAccessData,
    error: flpAccessError
  } = useFlpAccess((_flow$flowId = flow === null || flow === void 0 ? void 0 : flow.flowId) !== null && _flow$flowId !== void 0 ? _flow$flowId : NaN);
  const EnrollmentContainerComponent = isRevisionPreview ? RevisionEnrollmentContainer : EnrollmentContainer;
  const hasFlpWriteAccess = !flpAccessError && (flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.hasAccess(EDIT_ENROLLMENT));
  const {
    hasFeatureAccess: hasEditEnrollmentAccess
  } = useFeaturePermission({
    feature: EDIT_ENROLLMENT
  });
  const content = flow && /*#__PURE__*/_jsxs(_Fragment, {
    children: [showEventEnrollmentFeedbackSurvey && /*#__PURE__*/_jsx(FeedbackLoader, {
      onClientLoad: feedbackClient => feedbackClient.loadSurvey('CSAT', EVENT_TRIGGERS_BETA_SURVEY_ID)
    }), flow && /*#__PURE__*/_jsx(EnrollmentContainerComponent, {
      view: enrollmentView,
      flow: flow,
      flowId: params.flowId,
      revisionId: params.revisionId,
      updateEnrollmentCriteria: updateEnrollmentCriteria,
      onClose: () => {
        var _flow$flowId2;
        if (enrollmentView.includes('EVENT')) {
          setShowEventEnrollmentFeedbackSurvey(true);
        }
        history.push({
          pathname: getBaseCanvasRoute({
            flowId: (_flow$flowId2 = flow === null || flow === void 0 ? void 0 : flow.flowId) !== null && _flow$flowId2 !== void 0 ? _flow$flowId2 : NaN,
            params
          }),
          search: history.location.search
        });
      },
      readOnly: !!isRevisionPreview || !hasEditEnrollmentAccess || !hasFlpWriteAccess
    })]
  });
  return /*#__PURE__*/_jsx(DataPassingProviderWrapper, {
    actionConfigDataPanelDisplay: actionConfigDataPanelDisplay,
    onChangeActionConfigDataPanelDisplay: setActionConfigDataPanelDisplay,
    flowId: (_flow$flowId3 = flow === null || flow === void 0 ? void 0 : flow.flowId) !== null && _flow$flowId3 !== void 0 ? _flow$flowId3 : NaN,
    flowObjectTypeId: (_flow$objectTypeId = flow === null || flow === void 0 ? void 0 : flow.objectTypeId) !== null && _flow$objectTypeId !== void 0 ? _flow$objectTypeId : UNKNOWN_ID,
    isFlowEnabled: flow === null || flow === void 0 ? void 0 : flow.isEnabled,
    children: /*#__PURE__*/_jsx(ConfigPanel, {
      canvasScrollElementRef: scrollElementRef,
      width: getSidebarWidthForDataPanelState(actionConfigDataPanelDisplay),
      dataTestId: "event-enrollment-container",
      children: /*#__PURE__*/_jsxs(ColumnContainer, {
        children: [/*#__PURE__*/_jsx(LeftPanelContainer, {
          children: content
        }), actionConfigDataPanelDisplay !== DataPanelVisibleStates.CLOSED &&
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx(RightPanelContainer, {
          children: /*#__PURE__*/_jsx(DataPassingPanel, {})
        })]
      })
    })
  });
}